
import { getLogoPath } from "@/locales/i18n";
import { defineComponent, computed, inject } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const keycloak = inject("keycloak") as Keycloak.KeycloakInstance;
    const { t } = useI18n();

    const onClickLogout = () => {
      keycloak.logout({ redirectUri: window.origin });
    };

    return {
      t,
      onClickLogout,
      getLogoByLocale: computed(() => getLogoPath()),
    };
  },
});
